import { ITeamLeadPermissionsJson } from '@scale/shared/types/expertManagement';
import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useUpsertTeamLeadPermissions = () => {
  return useMutation((body: ITeamLeadPermissionsJson) =>
    apiFetch<ITeamLeadPermissionsJson>(null, 'internal/expert-management/permissions', {
      method: 'POST',
      body,
    }),
  );
};
